import { useContext } from "react";
import { ActivosContext } from "../pages/catalogos/ActivosPage";

export const ObtenerTiposServicio = async() => {
    return new Promise((resolve, reject) => {

        const data = new FormData();
        data.append('orden','TipoInstalacion asc')
         fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=tiposServicio', {
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))
    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
    })
}

export const GuardarNuevoTipoServicio = (tipoServicio, idTipoServicio) => {
    return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append('tipoServicio', tipoServicio);
        data.append('idTipoServicio', idTipoServicio);
        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=agregarTipoServicio',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}




export const EliminarTipoServicio = (idTipoServicio) => {
    return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append('idTipoServicio', idTipoServicio);
        fetch(process.env.REACT_APP_API_URL+'/instalaciones.php?funcion=eliminarTipoServicio',{
            method:'POST',
            body:data
        })
        .then(response => response.json())
        .then(datos => resolve(datos))

    })
    .then((datos) => {
        return datos
    })
    .catch(error => {
        console.warn(error);
        return error;
    })
}

